'use client'

import { ArrowLeft } from '@phosphor-icons/react'
import { useRouter } from 'next/navigation'

export function PageBackButton({
  fallbackHref = '/',
  className = 'flex items-center gap-3 text-lg font-medium text-[#202020]',
}: {
  fallbackHref?: string
  className?: string
}) {
  const router = useRouter()

  const goBack = () => {
    if (typeof window !== 'undefined' && window.history.length > 1) {
      router.back()
    } else {
      router.push(fallbackHref)
    }
  }

  return (
    <button
      type="button"
      onClick={goBack}
      className={className}
    >
      <ArrowLeft size={24} />
      <span>Back</span>
    </button>
  )
}
